import { buildAdvancedMatching, sendEventToServer } from "./utils";

export async function loadFacebookPixel() {
  const advancedMatching = buildAdvancedMatching();

  // Define the function and then call it
  const initFacebookPixel = async function () {
    if (window.fbq) return;
    let n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    let t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(t, s);

    // Initialize with any available advanced matching parameters
    if (Object.keys(advancedMatching).length > 0) {
      n("init", "396482213147417", advancedMatching);
    } else {
      n("init", "396482213147417");
    }
    n("track", "PageView");
  };

  // Execute the function
  initFacebookPixel();

  //send conversion
  sendEventToServer(advancedMatching, "PageView");
}

// Optionally, you can use the script tag for users with JavaScript disabled
export function noscriptPixel() {
  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src="https://www.facebook.com/tr?id=396482213147417&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
}
